export default "__VITE_ASSET__c67ee0b8__"